export default __webpack_public_path__ + "static/media/others-card.80229e07.png";